import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

let appGlobals = Vue.observable({  
  appVersion: import.meta.env.PACKAGE_VERSION
})

Vue.prototype.$appGlobals = appGlobals;
console.log("Version " + Vue.prototype.$appGlobals.appVersion);

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
